// import { useState } from 'react';
// import Loader from './components/loader/Loader';
import Routing from './Routes/Routing';

const App = () => {
  // const [loader, setLoader] = useState(false);

  return <Routing />;
};

export default App;
